/* ════════════════════════════════════════════════════════════
   KIDEO STORE — GEBOORTELIJST (Fase 1)
   Account-tab: lijsten aanmaken, tonen en de deel-link kopiëren.
   Productpagina: "Voeg toe aan geboortelijst" met een lijst-kiezer.
   Praat met de App Proxy /apps/proxy/geboortelijst (same-origin).
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function ingelogd() { return typeof window.KIDEO_KLANT === 'number'; }

  function api(qs, body) {
    return fetch('/apps/proxy/geboortelijst?' + qs, {
      method: body ? 'POST' : 'GET',
      headers: body ? { 'Content-Type': 'application/json' } : {},
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
    // We parsen ook bij 4xx: de backend geeft altijd {ok:false,fout:…}; callers
    // checken res.ok (JSON-veld), niet de HTTP-status.
  }

  var mijnLijsten = null; // cache

  function haalLijsten() {
    return api('actie=mijn').then(function (res) {
      mijnLijsten = (res && res.ok && res.lijsten) ? res.lijsten : [];
      return mijnLijsten;
    });
  }

  /* ── Account-tab: beheer ── */
  function initBeheer() {
    var paneel = document.querySelector('[data-gl-beheer]');
    if (!paneel) return;

    function melding(kaart, txt) {
      var m = kaart && kaart.querySelector('[data-gl-melding]');
      if (!m) return;
      m.textContent = txt;
      clearTimeout(m._t);
      m._t = setTimeout(function () { m.textContent = ''; }, 2400);
    }

    function itemHTML(it, arch) {
      var gegeven = (it.gekocht > 0) ? '<span class="glb__gegeven">' + it.gekocht + ' gegeven</span>' : '';
      return '<li class="glb__item" data-gl-item data-h="' + tekst(it.h) + '" data-v="' + tekst(it.v || '') + '" data-t="' + tekst(it.t || '') + '">' +
        '<span class="glb__inaam">' + tekst(it.t || it.h) + '</span>' + gegeven +
        '<label class="glb__aantal-in">aantal <input type="number" data-gl-aantal value="' + (it.gewenst || 1) + '" min="1" max="20"' + (arch ? ' disabled' : '') + '></label>' +
        (arch ? '' : '<button type="button" class="glb__itemweg" data-gl-itemweg aria-label="Verwijder van lijst">&times;</button>') +
        '</li>';
    }

    function kaartHTML(l) {
      var url = location.origin + '/apps/proxy/geboortelijst?token=' + encodeURIComponent(l.token);
      var arch = !!l.gearchiveerd;
      var items = l.items || [];
      return '<div class="glb__kaart kaart' + (arch ? ' is-arch' : '') + '" data-gl-kaart data-token="' + tekst(l.token) + '">' +
        '<div class="glb__kop"><strong>' + tekst(l.titel) + '</strong>' +
          '<span class="glb__aantal">' + l.aantal + ' cadeau' + (l.aantal === 1 ? '' : 's') + '</span>' +
          (arch ? '<span class="glb__badge">Gearchiveerd</span>' : '') + '</div>' +
        '<div class="glb__deel"><input readonly value="' + tekst(url) + '" data-gl-link>' +
          '<button type="button" class="btn btn--licht" data-gl-kopieer="' + tekst(url) + '">Kopieer link</button>' +
          '<a class="btn btn--licht" href="' + tekst(url) + '" target="_blank" rel="noopener">Bekijk</a></div>' +
        (items.length
          ? '<ul class="glb__items">' + items.map(function (it) { return itemHTML(it, arch); }).join('') + '</ul>'
          : '<p class="glb__geen">Nog geen cadeaus op deze lijst.</p>') +
        (arch ? ''
          : '<div class="glb__zoek">' +
              '<input type="search" class="glb__zoekveld" data-gl-zoekveld placeholder="Product zoeken om toe te voegen…" autocomplete="off">' +
              '<div class="glb__resultaten" data-gl-resultaten hidden></div>' +
            '</div>') +
        '<div class="glb__acties">' +
          '<button type="button" class="btn btn--licht" data-gl-arch>' + (arch ? 'Heropenen' : 'Archiveren') + '</button>' +
          (l.verwijderbaar ? '<button type="button" class="glb__wis" data-gl-lijstweg>Verwijderen</button>' : '') +
          '<span class="glb__melding" data-gl-melding></span>' +
        '</div>' +
        '</div>';
    }

    function render(lijsten) {
      var uit = '';
      if (lijsten.length) {
        uit += '<div class="glb__lijsten">' + lijsten.map(kaartHTML).join('') + '</div>';
      } else {
        uit += '<p class="glb__leeg">Je hebt nog geen geboortelijst. Maak er hieronder een aan en voeg producten toe (of via de knop op een productpagina).</p>';
      }
      uit += '<form class="glb__nieuw" data-gl-nieuw>' +
        '<input type="text" name="titel" placeholder="Titel, bv. Welkom kleine Fien" maxlength="120" required>' +
        '<button type="submit" class="btn btn--primary">Nieuwe lijst</button></form>';
      paneel.innerHTML = uit;
    }

    function tokenVan(el) { var k = el.closest('[data-gl-kaart]'); return k ? k.getAttribute('data-token') : ''; }

    /* Eén klik-handler voor het hele paneel (werkt ook na her-render). */
    paneel.addEventListener('click', function (e) {
      /* Deel-link kopiëren */
      var kop = e.target.closest('[data-gl-kopieer]');
      if (kop) {
        var v = kop.getAttribute('data-gl-kopieer');
        (navigator.clipboard ? navigator.clipboard.writeText(v) : Promise.reject())
          .then(function () { kop.textContent = 'Gekopieerd!'; setTimeout(function () { kop.textContent = 'Kopieer link'; }, 1500); })
          .catch(function () { var i = kop.closest('.glb__deel').querySelector('[data-gl-link]'); i.focus(); i.select(); });
        return;
      }
      /* Product uit de zoekresultaten toevoegen */
      var res = e.target.closest('[data-gl-resultaat]');
      if (res) {
        var kaartR = res.closest('[data-gl-kaart]');
        var itemR = { h: res.getAttribute('data-h'), v: '', t: res.getAttribute('data-t'), gewenst: 1 };
        melding(kaartR, 'Toevoegen…');
        api('actie=item', { token: kaartR.getAttribute('data-token'), item: itemR }).then(function (r) {
          if (r && r.ok) { haalLijsten().then(render); }
          else { melding(kaartR, (r && r.fout) || 'Toevoegen mislukt'); }
        });
        return;
      }
      /* Item van de lijst halen */
      var iw = e.target.closest('[data-gl-itemweg]');
      if (iw) {
        var li = iw.closest('[data-gl-item]');
        var kaartI = iw.closest('[data-gl-kaart]');
        iw.disabled = true;
        api('actie=verwijder', { token: kaartI.getAttribute('data-token'),
          item: { h: li.getAttribute('data-h'), v: li.getAttribute('data-v'), t: li.getAttribute('data-t'), gewenst: 1 } })
          .then(function (r) {
            if (r && r.ok) { haalLijsten().then(render); }
            else { iw.disabled = false; melding(kaartI, 'Verwijderen mislukt'); }
          });
        return;
      }
      /* Archiveren / heropenen */
      var arch = e.target.closest('[data-gl-arch]');
      if (arch) {
        var kaartA = arch.closest('[data-gl-kaart]');
        var nuArch = kaartA.classList.contains('is-arch');
        arch.disabled = true;
        api('actie=archiveer', { token: kaartA.getAttribute('data-token'), gearchiveerd: !nuArch }).then(function (r) {
          if (r && r.ok) { haalLijsten().then(render); }
          else { arch.disabled = false; melding(kaartA, 'Mislukt'); }
        });
        return;
      }
      /* Lijst verwijderen (alleen zichtbaar als er niets is ingeboekt) */
      var wis = e.target.closest('[data-gl-lijstweg]');
      if (wis) {
        var kaartW = wis.closest('[data-gl-kaart]');
        if (!window.confirm('Deze geboortelijst verwijderen? Dit kan niet ongedaan worden gemaakt.')) return;
        wis.disabled = true;
        api('actie=verwijder-lijst', { token: kaartW.getAttribute('data-token') }).then(function (r) {
          if (r && r.ok) { haalLijsten().then(render); }
          else {
            wis.disabled = false;
            melding(kaartW, (r && r.archiveer) ? 'Er zijn al cadeaus ingeboekt — archiveer de lijst.' : ((r && r.fout) || 'Verwijderen mislukt'));
          }
        });
        return;
      }
    });

    /* Aantal gewenst wijzigen */
    paneel.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-gl-aantal]');
      if (!inp) return;
      var li = inp.closest('[data-gl-item]');
      var kaart = inp.closest('[data-gl-kaart]');
      var g = Math.max(1, Math.min(20, parseInt(inp.value, 10) || 1));
      inp.value = g;
      inp.disabled = true;
      api('actie=item', { token: kaart.getAttribute('data-token'),
        item: { h: li.getAttribute('data-h'), v: li.getAttribute('data-v'), t: li.getAttribute('data-t'), gewenst: g } })
        .then(function (r) { inp.disabled = false; melding(kaart, (r && r.ok) ? 'Opgeslagen ✓' : 'Opslaan mislukt'); });
    });

    /* Nieuwe lijst aanmaken */
    paneel.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-gl-nieuw]');
      if (!form) return;
      e.preventDefault();
      var knop = form.querySelector('button');
      knop.disabled = true;
      api('actie=nieuw', { titel: form.titel.value.trim() }).then(function (res) {
        knop.disabled = false;
        if (res && res.ok) { haalLijsten().then(render); form.reset(); }
      });
    });

    /* Productzoeker (predictive search van de winkel, same-origin) */
    var zoekTimer = null;
    paneel.addEventListener('input', function (e) {
      var veld = e.target.closest('[data-gl-zoekveld]');
      if (!veld) return;
      var bak = veld.closest('[data-gl-kaart]').querySelector('[data-gl-resultaten]');
      var q = veld.value.trim();
      clearTimeout(zoekTimer);
      if (q.length < 2) { bak.hidden = true; bak.innerHTML = ''; return; }
      zoekTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            var prods = (d && d.resources && d.resources.results && d.resources.results.products) || [];
            if (!prods.length) { bak.hidden = false; bak.innerHTML = '<div class="glb__geenres">Niets gevonden</div>'; return; }
            bak.hidden = false;
            bak.innerHTML = prods.map(function (p) {
              var foto = p.image || p.featured_image || '';
              return '<button type="button" class="glb__res" data-gl-resultaat data-h="' + tekst(p.handle) + '" data-t="' + tekst(p.title) + '">' +
                (foto ? '<img src="' + tekst(foto) + '" alt="" loading="lazy">' : '<span class="glb__resnofoto"></span>') +
                '<span class="glb__restitel">' + tekst(p.title) + '</span></button>';
            }).join('');
          }).catch(function () { bak.hidden = true; });
      }, 250);
    });

    haalLijsten().then(render);
  }

  /* ── Productpagina: toevoegen aan een lijst ── */
  function initKnop() {
    var knop = document.querySelector('[data-gl-toevoegen]');
    if (!knop) return;

    if (!ingelogd()) {
      knop.addEventListener('click', function () {
        window.location.href = '/account/login?return_url=' + encodeURIComponent(location.pathname);
      });
      return;
    }

    var dialoog = document.querySelector('[data-gl-dialoog]');
    knop.addEventListener('click', function () {
      openDialoog(dialoog, knop);
    });
  }

  function openDialoog(dialoog, knop) {
    var vorm = document.querySelector('[data-product-form] [data-variant-id]');
    var variant = vorm ? vorm.value : (knop.getAttribute('data-variant') || '');
    var kies = dialoog.querySelector('[data-gl-kies]');
    var melding = dialoog.querySelector('[data-gl-melding]');
    melding.textContent = '';

    haalLijsten().then(function (lijsten) {
      var opties = lijsten.filter(function (l) { return !l.gearchiveerd; }).map(function (l) {
        return '<label class="gld__optie"><input type="radio" name="gl-lijst" value="' + tekst(l.token) + '"> ' + tekst(l.titel) + '</label>';
      }).join('');
      opties += '<label class="gld__optie gld__optie--nieuw"><input type="radio" name="gl-lijst" value="__nieuw"> Nieuwe lijst…</label>';
      kies.innerHTML = opties +
        '<input type="text" class="gld__titel" data-gl-titel placeholder="Titel nieuwe lijst" maxlength="120" hidden>' +
        '<label class="gld__aantal">Aantal gewenst <input type="number" data-gl-gewenst value="1" min="1" max="20"></label>';
      var eerste = kies.querySelector('input[name="gl-lijst"]');
      if (eerste) eerste.checked = true;
      toggleTitel();
    });

    function toggleTitel() {
      var gekozen = kies.querySelector('input[name="gl-lijst"]:checked');
      var titel = kies.querySelector('[data-gl-titel]');
      if (titel) titel.hidden = !(gekozen && gekozen.value === '__nieuw');
    }
    kies.onchange = toggleTitel;

    if (typeof dialoog.showModal === 'function') dialoog.showModal();
    else dialoog.setAttribute('open', '');

    dialoog.querySelector('[data-gl-bevestig]').onclick = function () {
      var gekozen = kies.querySelector('input[name="gl-lijst"]:checked');
      if (!gekozen) return;
      var gewenst = Math.max(1, parseInt(kies.querySelector('[data-gl-gewenst]').value, 10) || 1);
      var item = {
        h: knop.getAttribute('data-handle'),
        v: variant,
        t: knop.getAttribute('data-titel') || '',
        gewenst: gewenst
      };
      var knopB = dialoog.querySelector('[data-gl-bevestig]');
      knopB.disabled = true; melding.textContent = 'Bezig…';

      var vervolg = function (token) {
        return api('actie=item', { token: token, item: item }).then(function (res) {
          knopB.disabled = false;
          if (res && res.ok) { melding.textContent = 'Toegevoegd aan je lijst ✓'; setTimeout(sluit, 1100); }
          else { melding.textContent = (res && res.fout) || 'Er ging iets mis, probeer opnieuw.'; }
        });
      };

      if (gekozen.value === '__nieuw') {
        var titelV = (kies.querySelector('[data-gl-titel]').value || '').trim() || 'Onze geboortelijst';
        api('actie=nieuw', { titel: titelV }).then(function (res) {
          if (res && res.ok) { mijnLijsten = null; vervolg(res.token); }
          else { knopB.disabled = false; melding.textContent = 'Aanmaken mislukt.'; }
        });
      } else {
        vervolg(gekozen.value);
      }
    };
    function sluit() { if (dialoog.close) dialoog.close(); else dialoog.removeAttribute('open'); }
    dialoog.querySelector('[data-gl-sluit]').onclick = sluit;
  }

  function tekst(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function euro(c) { return '€ ' + (c / 100).toFixed(2).replace('.', ','); }

  /* ── Publieke deel-pagina: inhoud komt als JSON (actie=items), veilig
        client-side gerenderd — geen eigenaar-tekst in de Liquid-stroom. ── */
  function initPubliek() {
    var wortel = document.querySelector('[data-gl-publiek]');
    if (!wortel) return;
    var token = wortel.getAttribute('data-gl-token');
    var kop = wortel.querySelector('[data-gl-kop]');
    var houder = wortel.querySelector('[data-gl-lijst]');
    var leeg = wortel.querySelector('[data-gl-leeg]');

    api('actie=items&token=' + encodeURIComponent(token)).then(function (res) {
      if (!res || !res.ok) { leeg.hidden = false; leeg.textContent = 'Deze lijst kon niet geladen worden.'; return; }
      var h1 = document.createElement('h1');
      h1.textContent = res.titel || 'Geboortelijst';
      kop.appendChild(h1);
      if (res.boodschap) {
        var p = document.createElement('p');
        p.className = 'gl__boodschap';
        p.textContent = res.boodschap;
        kop.appendChild(p);
      }
      var intro = document.createElement('p');
      intro.className = res.gesloten ? 'gl__gesloten' : 'gl__intro';
      intro.textContent = res.gesloten
        ? 'Deze geboortelijst is gesloten — er kan niet meer besteld worden.'
        : 'Kies een cadeau hieronder — het wordt automatisch van de lijst gehaald zodra het gekocht is.';
      kop.appendChild(intro);

      var items = res.items || [];
      if (!items.length) { leeg.hidden = false; leeg.textContent = 'Er staan nog geen cadeaus op deze lijst.'; return; }
      houder.hidden = false;
      items.forEach(function (item) { renderCadeau(houder, item, res.gesloten); });
    });

    houder.addEventListener('click', function (e) {
      var koop = e.target.closest('[data-gl-koop]');
      if (!koop || !koop.dataset.variant) return;
      koop.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(koop.dataset.variant), quantity: 1, properties: { '_geboortelijst': token } }] })
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { koop.disabled = false; });
    });
  }

  function renderCadeau(houder, item, gesloten) {
    var beschikbaar = Math.max(0, (item.gewenst || 1) - (item.gekocht || 0));
    var kanKopen = beschikbaar > 0 && !gesloten;
    var kaart = document.createElement('div');
    kaart.className = 'pkaart kaart gl__kaart' + (kanKopen ? '' : ' is-op');
    kaart.innerHTML =
      '<a class="pkaart__foto-link" data-gl-link tabindex="-1"><div class="pkaart__foto"></div></a>' +
      '<a class="pkaart__naam" data-gl-naam></a>' +
      '<div class="pkaart__prijsrij"><span class="pkaart__prijs" data-gl-prijs></span></div>' +
      '<span class="gl__status ' + (kanKopen ? 'gl__status--kan' : 'gl__status--op') + '"></span>' +
      (kanKopen ? '<button type="button" class="btn btn--primary gl__koop" data-gl-koop>Koop dit cadeau</button>' : '');
    houder.appendChild(kaart);
    kaart.querySelector('.gl__status').textContent = gesloten
      ? 'Lijst gesloten'
      : (beschikbaar ? ('Nog ' + beschikbaar + ' van ' + item.gewenst + ' gewenst') : 'Al gegeven ✓');

    var url = '/products/' + item.h + (item.v ? '?variant=' + item.v : '');
    kaart.querySelector('[data-gl-link]').setAttribute('href', url);
    kaart.querySelector('[data-gl-naam]').setAttribute('href', url);

    fetch('/products/' + item.h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return;
      var v = item.v ? p.variants.find(function (x) { return String(x.id) === String(item.v); }) : null;
      if (!v) v = p.variants[0];
      kaart.querySelector('[data-gl-naam]').textContent = p.title;
      kaart.querySelector('[data-gl-prijs]').textContent = euro(v.price);
      if (p.featured_image) {
        var img = document.createElement('img');
        img.setAttribute('src', p.featured_image);
        img.setAttribute('alt', '');
        img.setAttribute('loading', 'lazy');
        kaart.querySelector('.pkaart__foto').appendChild(img);
      }
      var koop = kaart.querySelector('[data-gl-koop]');
      if (koop) koop.dataset.variant = v.id;
    });
  }

  function init() { initBeheer(); initKnop(); initPubliek(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
